import { render, staticRenderFns } from "./PortalSidebar.vue?vue&type=template&id=a56a484c"
import script from "./PortalSidebar.vue?vue&type=script&lang=js"
export * from "./PortalSidebar.vue?vue&type=script&lang=js"
import style0 from "./PortalSidebar.vue?vue&type=style&index=0&id=a56a484c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports